
export default function isNotPassNumberRangeChk(value, min, max) {
    if(min === null){
        return parseInt(value, 10) >= max;
    }else if(max === null){
        return parseInt(value, 10) <= min;
    }
    return parseInt(value, 10) <= min || parseInt(value, 10) >= max;
}
